import {createReducer} from "typesafe-actions";
import { getAllTreeAsync, getTreeLiveAsync, getTreeRatingAsync } from '../actions';

export const loadedTree = createReducer(false)
    .handleAction(getTreeLiveAsync.request, () => false)
    .handleAction(getTreeLiveAsync.success, () => true)
    .handleAction(getTreeLiveAsync.failure, () => true)
    .handleAction(getTreeLiveAsync.cancel, () => true)

    .handleAction(getAllTreeAsync.request, () => false)
    .handleAction(getAllTreeAsync.success, () => true)
    .handleAction(getAllTreeAsync.failure, () => true)
    .handleAction(getAllTreeAsync.cancel, () => true)

    .handleAction(getTreeRatingAsync.request, () => false)
    .handleAction(getTreeRatingAsync.success, () => true)
    .handleAction(getTreeRatingAsync.failure, () => true)
    .handleAction(getTreeRatingAsync.cancel, () => true)
